import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Visible } from 'coreOld/components';
import { ITab } from 'coreOld/types';

interface IProps {
  icon?: JSX.Element;
  title: string;
  isSelected?: boolean;
  url?: string;
  onClick: (tab: ITab) => void;
}

type WrapperProps = { children?: ReactNode; onClick?: any };

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

type TabWrapperProps = { selected?: boolean; children?: ReactNode };

export const TabWrapper = styled.a<TabWrapperProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  font: 400 14px 'Open Sans';
  padding: 15px 1.5vw;
  position: relative;
  width: 100%;
  white-space: nowrap;
  transition: all 0.3s linear;

  &:hover {
    background-color: ${({ theme }) => theme.palette.backgrounds.main};
    cursor: pointer;
  }
`;

type IconWrapperProps = { children?: ReactNode };

export const IconWrapper = styled.div<IconWrapperProps>`
  margin-right: 10px;
`;

type TitleProps = { selected?: boolean; children?: ReactNode };

export const Title = styled.span<TitleProps>`
  padding-bottom: 5px;

  ${({ selected }) =>
    selected &&
    css`
      border-bottom: 3px solid #009ddc;
    `}
`;

const TableTab = ({ icon, title, onClick, isSelected }: IProps) => {
  return (
    <Wrapper onClick={onClick}>
      <TabWrapper selected={isSelected}>
        <Visible when={Boolean(icon)}>
          <IconWrapper>{icon}</IconWrapper>
        </Visible>

        <Title selected={isSelected}>{title}</Title>
      </TabWrapper>
    </Wrapper>
  );
};

export default TableTab;
